<template>
    <div ref="chart" :key="chartKey" style="width: 100%; height: 60px;"></div>
  </template>

  <script>
  import * as echarts from 'echarts';
  import { onMounted, ref, watch } from 'vue';
  import { useI18n } from 'vue-i18n';

  export default {
    props: {
        data: {
            type: Array,
            required: true,
            default: () => [],
        },
    },

    setup(props) {
      const chart = ref(null);
      const chartKey = ref(0);
      const { t } = useI18n();

        watch(() => props.data, () => {
            chartKey.value += 1;
        });

      const initChart = () => {
        // Ініціалізація графіка
        const myChart = echarts.init(chart.value);

        // Параметри графіка
        const options = {
            tooltip: {},
            grid: {
                top: 0,
                bottom: 0,
                left: 20,
                right: 20, // Прибираємо всі відступи навколо графіка
                containLabel: true // Залишаємо місце для підписів осі X
            },
            xAxis: {
                type: 'category',
                data: [
                    t('mounthesMini.january'),
                    t('mounthesMini.february'),
                    t('mounthesMini.march'),
                    t('mounthesMini.april'),
                    t('mounthesMini.may'),
                    t('mounthesMini.june'),
                    t('mounthesMini.july'),
                    t('mounthesMini.august'),
                    t('mounthesMini.september'),
                    t('mounthesMini.october'),
                    t('mounthesMini.november'),
                    t('mounthesMini.december')],
                axisLabel: {
                    show: true // Підписи під стовпчиками
                },
                axisTick: {
                    show: false
                },
                axisLine: {
                    show: false
                },
            },
            yAxis: {
                type: 'value',
                axisLine: {
                    show: false // Прибираємо лінію осі Y
                },
                axisTick: {
                    show: false // Прибираємо позначки осі Y
                },
                axisLabel: {
                    show: false // Прибираємо підписи осі Y
                },
                splitLine: {
                    show: false // Прибираємо лінії сітки вздовж осі Y
                }
            },
            series: [
                {
                    name: t('barChart.paid'),
                    type: 'bar',
                    data: props.data?.length ? props.data : [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],

                    itemStyle: {
                        color: '#C7C8D1' // Колір стовпчиків
                    },

                    barMinHeight: 2
                },
            ]
        };

        // Налаштування параметрів
        myChart.setOption(options);

        // Обробка зміни розміру вікна
        window.addEventListener('resize', () => {
          myChart.resize();
        });
      };

      onMounted(() => {
        initChart();
      });

      return {
        chart,
        chartKey
      };
    }
  };
  </script>

  <style scoped>
  /* За потреби додайте стилі для контейнера графіка */
</style>
